/**
 * Whether a key pressed on `target` is typing: a text control or an editable region
 * owns it, so a page-level shortcut must leave it alone.
 */
export default function isEditableTarget(target: EventTarget | null): boolean {
  return (
    target instanceof HTMLElement &&
    (target.isContentEditable || target.matches('input, textarea, select'))
  );
}
